// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
        // suggestionStyle: 'style2',
        suggestionMobileStyle: 'style2',
        suggestionStyle2MainContainerSelector: '#boost-pfs--ced-search-result-container',
      	suggestionStyle2MobileContainerSelector: '.predictive-search__content-wrapper',
        
	}
};

(function() {
	BoostPFS.inject(this);
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

    // Boost 199406
    // var fixMobileISW = () => {
    //     var drawerWidth = 400;
    //     if(jQ('#search-drawer').length > 0) {
    //       drawerWidth = jQ('#search-drawer')[0].clientWidth;
    //     }
    // 	var styles = `@media only screen and (max-width:767px){.boost-pfs-search-suggestion-wrapper {width:${drawerWidth}px !important} .boost-pfs-search-suggestion-wrapper.boost-pfs-search-suggestion-open{width:${drawerWidth}px !important}}`;
    
    //   var styleSheet = document.createElement("style")
    //   styleSheet.innerText = styles
    //   document.head.appendChild(styleSheet)
    // }
    // fixMobileISW();
    // END Boost 199406
})();